import { Component, OnInit } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from '.../../environments/environment';
import { Broadcaster } from '.../../environments/broadcaster';
import { AuthService } from '../../../_services/index';
import { LoaderService } from 'app/_services/loader.service';
import { utils, write, WorkBook } from 'xlsx';
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2'
declare var $: any;

import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
import { LogicalRowDirective } from '@progress/kendo-angular-grid';

const moment = _rollupMoment || _moment;


@Component({
  selector: 'DriverVehdetails',
  templateUrl: './DriverVehdetails.component.html',
  styleUrls: ['./DriverVehdetails.component.css'],
})

export class DriverVehdetailsComponent implements OnInit {
  map: any
  showLoader: boolean;
  public Id;
  public data;
  public userId: any;
  public areaEntityData;
  public staffEntityData;
  public prjData;
  public vehNo;
  public VehiclesByID;
  public VehiclesDataStatus;
  selectedRow: Number;
  selectedAreaRow: Number;
  setClickedRow: Function;
  selectAreaEntityDetailsRow: Function;
  //selectStaffEntityDetailsRow :Function;
  public vehiclesCatogery;
  public vehiclesArealabel: any;
  public stdate: any
  public enddate: any
  public selectPrjId: any
  public SelectVehno: any
  public deleted = false;
  public delwarning = false;
  public updtVehDataSuccess = false;
  public VehicleParkLocation: any
  public selectProjectmodel: any
  public vehAreaModel: any
  public vehiclesAreaEntity: any
  public vehAssignmtStaffRole: any
  public vehStaffRoleModel: any
  public staffRole: any
  public staffNameData: any
  public areaAssignDetails: any
  public staffAssignDetails: any
  public vehStaffNameModel: any
  public vehStaffAsignStatus: any
  
  search: any;
  showDialog: any
  visible: any
  //---------------vehicles Update Details-------------
  //For Update validations  
  public udptVehTypename = false;
  public selectedDate= moment();
  public updtImeiNo = false;
  public udptParkLocation = false;
  public udptDataStatus = false;
  public saveAreaEntityStatus = false;
  public saveStaffNameStatus = false;
  public deleteAreaEntity = false;
  public vehStaffRoleStatus = false;
  public vehStaffRoleNameStatus = false;
  public isVehAssignSave = false;
  public isStaffAssignSave = false;
  public vehiclesNo: any
  public vehTypId: any
  public vehType: any
  public vehCotegaryId: any
  public vehiclesType: any;
  public inActiveVehiclesLst: any;
  public SelectProjectName: any
  public vehCotId: any
  public vehTypeId: any
  public VehiclesNo: any
  public imeidNo: any
  public chaChihNo: any
  public vtsMobileNo: any
  public simNo: any
  public vtsModel: any
  public parkLocations: any
  public installDate: any
  public activationsDate: any
  public vehDataStatus: any
  public isjingleActive: any
  public isActiveStatus: any
  public selectedRowData: any
  public Prjid: any
  public updtCheckVehnoAvl: any
  public updtCheckVehMobileImeiNoAvl: any
  public updtCheckVtsMobileNoAvt: any
  public updtCheckVehChasisNoAvt: any
  public updtCheckSimNoAvt: any
  public vehCatArea: any
  public vehlabelId: any
  public vehEntityArea = false;
  public vehStaffStatus = false;
  public vehAreaEntityModel: any
  public vehEntityData: any
  public vehAreaAsignStatus: any
  public vehStaffRoleId: any
  public project: any
  public updateData: any
  public updtVstDeviceNo: any
  public updtGsmOperator: any
  public updtEntryDate: any
  public currentDate: any
  public projectMaster: any;
  public showHideVehAssignLoadDiv = false;
  public showHideStaffAssignLoadDiv = false
  public imageVehAssignLoader: any;
  public imageStaffAssignLoader: any;
  public vehUpdateBtnDiv = false;
  public vehDeleteBtnDiv = false;
  public vehAssignmentBtnDiv = false;
  public vehActiveBtnDiv = false;
  public showHideVehNoDiv = false;
  public isVehicleUpdtbtn = false;
  public showHideImeiNoDiv = false;
  public imgVehNoPath: any;
  public imgVehImeiNoPath: any;
  public showHideChasisNoDiv: any;
  public imgChasisNoPath: any;
  public imgVtsMobilNoPath: any;
  public showHideVtsMobileDiv = false;
  public imgSimNoPath: any;
  public showHideSimNoDiv = false;
  public employeeRecordNotFound = false;
  public vehAreaRecordNotFound = false;
  public staffAssignReNotFound = false;
  public vehID: any;
  //public staffSelectionsId:any;
  public vtsModalaData: any;
  public vtsData: any;
  public vehOwnerTypeList: any;
  public ownerType: any;
  public VehiclesTempNo: any;
  public vehOwnerTypeData: any;
  public ownerNameModal: any;
  public vtsModal: any;
  public vehOwnerRequired = false;
  public vtsModelRequired = false;
  public updtResponceMsg: any;
  public updtVehDataError = false;
  public saveAreaEntityError = false
  public saveStaffNameError = false;
  public date = moment();
  public polyCords=[];
  routeBoundary;
  changeStatus: any;
  status: any;
  titleData: any;
  successMsg: any;
  currentVehicleId: any;
  driverHistoryData: any;
  routeSelected: boolean;
  beatDetails: any;
  beatName: any;
  routeDetails: any;
  isBeatNull: boolean;
  routeList: any;
  isRouteSelected: boolean;
  singleRouteDetails: any;
  isNameUpdating: boolean;
  routeName: any;
  updateNameSuccess: boolean;
  updateNameError: boolean;
  selectedRouteId: any;
  geocoder: google.maps.Geocoder;
  routePolygondData: any;
  authtoken: any;
  polygondData: any;
  routePath: any[];
  route: google.maps.Polyline;
  
  tempVehiclesData: any;
  vehiclesData: any;
  selectedVehs: any;
  formattedSelectedDate: string;
  routesData:any
  alarmList: any;

  allalaramdata : any ;


  singleVehAlarmPoints: any;
  testing: any;
  km: any;
  
  constructor(private http: HttpClient, private broadcaster: Broadcaster, private auth: AuthService, private loaderService: LoaderService) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });
    this.vehOwnerTypeList = [{ "ID": 1, "VALUE": "Ecogreen" }, { "ID": 2, "VALUE": "Contractor" }]
    this.authtoken = JSON.parse(localStorage.getItem('authData'));
    this.selectedVehs = [];
    this.formattedSelectedDate = moment().format('YYYY-MM-DD');
  }
  ngOnInit(): void {

     
    
    $("#progress-bar").hide()
    this.Prjid = this.auth.getAuthentication().projectId
    this.userId = this.auth.getAuthentication().id;
    if (this.Prjid == 1) {
      this.SelectProjectName = "LUCKNOW";
    } else if (this.Prjid == 2) {
      this.SelectProjectName = "GURUGRAM";
    } else if (this.Prjid == 3) {
      this.SelectProjectName = "FARIDABAD";
    } else if (this.Prjid == 4) {
      this.SelectProjectName = "GWALIOR";
    }
  
    this.getAllVehiclesDrivresMapDetails()
    
  }

  getAllVehiclesDrivresMapDetails() {
    //this.loaderService.display(true);
   
    
    this.http.get(environment.apiUrl + 'admin/getAllVehiclesDrivresMapDetails?prjid=' + this.Prjid).subscribe((data) => {

       
            
      console.log(this.formattedSelectedDate = moment().format('YYYY-MM-DD'));
      
      this.data = data;

       console.log(this.data);
       

    if (this.data.length > 0) {
         this.loaderService.display(false);
      }
      else {
         this.loaderService.display(false);
      }
    });
  } 



 
  


  

  
  
  
  
  







 
  






 



  

  createRoute(map, pathCoords) {
    var i, route, marker;

    if(this.polyCords.length > 0)
      {
          
        this.polyCords = [];
        this.route.setMap(null);
        this.route = null;
      }


      for (i = 0; i < pathCoords.length; i++) {
        this.polyCords.push({ lat: JSON.parse(pathCoords[i][1]), lng: JSON.parse(pathCoords[i][0]) });
    } 
    this.routePath = this.polyCords;
    this.route = new google.maps.Polyline({
        path: this.polyCords,
        
        strokeColor: '#E2EF16',
        strokeOpacity: 4.0,
        strokeWeight: 5,
       
        //map: map
    });
    this.route.setMap(map);
 }


  importVehiclesExcelReport(data) {
    const ws_name = 'VehicleReport';
    const wb: WorkBook = { SheetNames: [], Sheets: {} };
    const ws: any = utils.json_to_sheet(data);
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    const wbout = write(wb, {
      bookType: 'xlsx', bookSST: true, type:
        'binary'
    });
    saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'exported.xlsx');
  }

  s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xFF;
    };
    return buf;
  }


   /// second km  one vrhicle

   async newrefreshCount(id,IMEI) {
    
    
  
    var dataObj = {
        prjId: this.Prjid,
        date: moment(this.date).format('YYYY-MM-DD')
    };

    
   await this.http.post(environment.apiUrl + 'getVehicleAlarms', dataObj).subscribe((data) => {
        this.alarmList = data;

          


           this.singleVehAlarmPoints = this.alarmList.filter(
            (item) => item.IMEI == IMEI && item.alarmTypeId ==  1
           );
            
             var len = this.singleVehAlarmPoints.length

             var newArrytwo =[] ;
              
            
             
             //console.log(this.singleVehAlarmPoints[0].lat,this.singleVehAlarmPoints[0].long);
             

           for(var i = 0; i < this.singleVehAlarmPoints.length; i++)
           {
              //this.singleVehAlarmPoints[0].lat,this.singleVehAlarmPoints[0].long

              newArrytwo.push({lat:parseFloat(this.singleVehAlarmPoints[i].lat),lng:parseFloat(this.singleVehAlarmPoints[i].long)})
           } 

         //console.log(newArrytwo);
         

        var newCordss = new google.maps.Polyline({
           path: newArrytwo,
           strokeColor: '#121C11',
           strokeOpacity: 0.0,
           strokeWeight: 0,
           //map: this.map
     
       });

       var testing = 	google.maps.geometry.spherical.computeLength(newCordss.getPath()); 

       // console.log(testing);
         
                
       
    });


  
    
  
    
   }
   

   async alarmsDataKM(totalImei) {

    return new Promise((resolve ,reject)=>{
      var dataObj = {
        prjId: this.Prjid,
        date: moment(this.date).format('YYYY-MM-DD')
       };
       
   
        this.http.post(environment.apiUrl + 'getVehicleAlarms', dataObj).subscribe((data)=>{
         
  
           this.allalaramdata = data
          if(this.allalaramdata > 0)
            {
              this.singleVehAlarmPoints = this.allalaramdata.filter(
                (item) => item.IMEI == totalImei && item.alarmTypeId ==  1
               );
    
               var len = this.singleVehAlarmPoints.length
    
               var newArrytwo =[] ;
                
               //console.log(this.singleVehAlarmPoints[0].lat,this.singleVehAlarmPoints[0].long);
               
    
             for(var i = 0; i < this.singleVehAlarmPoints.length; i++)
             {
                //this.singleVehAlarmPoints[0].lat,this.singleVehAlarmPoints[0].long
    
                newArrytwo.push({lat:parseFloat(this.singleVehAlarmPoints[i].lat),lng:parseFloat(this.singleVehAlarmPoints[i].long)})
             } 
    
           //console.log(newArrytwo);
           
    
          var newCordss = new google.maps.Polyline({
             path: newArrytwo,
             strokeColor: '#121C11',
             strokeOpacity: 0.0,
             strokeWeight: 0,
             //map: this.map
       
         });
    
         this.testing = 	google.maps.geometry.spherical.computeLength(newCordss.getPath()); 
    
         //console.log("859", this.testing);
        
         resolve(this.testing) ;
            }

            else
            {
              resolve(0) ;
            }

          
         
  
       }
  
  
       )
  
  });

  
  }







  ////// save cron data testing #atul


  saveCronData(){

    console.log("testing");
    this.http.get(environment.apiUrl + 'vehicles/saveCronData?prjid='+2).subscribe((data)=>{

      console.log(data);
      


    })


  }






} 


// WEBPACK FOOTER //
// ./src/app/admin/vehicles/DriversAndVehicles/DriverVehdetails.component.ts